require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-the-future-of-wordpress.json") })
        }
      }, "path---blog-the-future-of-wordpress");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-the-future-of-wordpress!./.cache/json/blog-the-future-of-wordpress.json
// module id = 1065
// module chunks = 231608221292675